"use client";

import { Button } from "@mui/material";
import { useNotifyDialog } from "../Providers/NotifyDialogContext";

export default function CancelButton() {
  const { closeNotificationsDialog } = useNotifyDialog();

  const handleCancel = () => {
    closeNotificationsDialog();
  };

  return (
    <Button onClick={handleCancel} type="button">
      Cancel
    </Button>
  );
}
